import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 30px;\n\n  @media screen and (max-width: ", "px) {\n    margin: 0 20px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin: 0 20px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    outline-offset: 2px;\n    outline: 2px solid ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  ", "\n\n  vertical-align: bottom;\n\n  @media screen and (max-width: ", "px) {\n    width: 28px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    width: 24px;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Link } from 'react-router-dom';
import LogoPath from '../assets/icons/acorns-logo.svg';
import styled from '../utils/styling/styled-components';
var Logo = styled.img(_templateObject(), function (props) {
  return props.width ? "".concat(props.width, "px") : '33px';
}, function (props) {
  return props.height && "height: ".concat(props.height, "px;");
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var LogoButton = styled(Link)(_templateObject2(), function (props) {
  return props.theme.colors.green;
});
var LogoContainer = styled.div(_templateObject3(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.sm;
});
/**
 * This component is written with the assumption that we are
 * using react router in the consumer.
 */

var AcornsLogo = function AcornsLogo(_ref) {
  var link = _ref.link,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(LogoContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(LogoButton, {
    "aria-label": "Home Button",
    to: link
  }, /*#__PURE__*/React.createElement(Logo, {
    tabIndex: -1,
    src: LogoPath,
    alt: "Acorns logo",
    width: width,
    height: height
  })));
};

export { AcornsLogo };